import { CustomerNotificationCategory, CustomerNotificationType, PayrollType } from '../shared/enums/smarthub-enums';
import * as _ from 'lodash';
import { AlertNotificationDetails } from './alert-notification-details.model';

export class CustomerNotificationCounts {
    readonly category: CustomerNotificationCategory;
    readonly unAcknowledged: number;
    readonly acknowledgedRecently: number;
    filtered: number = undefined;
    isRefreshing = false;

    constructor(init?: Partial<CustomerNotificationCounts>) {
        Object.assign(this, init);
    }

    get total(): number {
        return this.unAcknowledged + this.acknowledgedRecently;
    }

    get hasUnAcknowledged(): boolean {
        return this.unAcknowledged > 0;
    }

    get isFiltered(): boolean {
        return this.filtered !== undefined && this.filtered < this.total;
    }
}

export class CustomerNotification {
  static readonly typesWithReturnedFunds: CustomerNotificationType[] = [
    CustomerNotificationType.BankNotificationPayRejection,
    CustomerNotificationType.BankNotificationPayReturn
  ];
  static get typesWithoutReturnedFunds(): CustomerNotificationType[] {
    const isIndex = function(key): boolean {
      const n = Number(key);
      return String(n) === key && n >= 0;
    };
    const allTypes: CustomerNotificationType[] = Object.keys(CustomerNotificationType)
      .filter(key => !isIndex(key))
      .map(n => CustomerNotificationType[n]);
    return _(allTypes).difference(this.typesWithReturnedFunds).value();
  }

  id: string;
  category: CustomerNotificationCategory;
  type: CustomerNotificationType;
  payrollInstanceId: string;
  companyId: string;
  payUtcDate: Date;
  payGroup: string;
  payrollDescription: string;
  payrollType: PayrollType;
  acknowledged: boolean;
  acknowledgedUtcDateTime: Date;
  acknowledgedBy: string;
  cancelled: boolean;
  metadata: object;
  details: AlertNotificationDetails;

  showDetails: boolean;

  constructor(init?: Partial<CustomerNotification>) {
    Object.assign(this, init);
  }

  get isNoc(): boolean {
    return this.type === CustomerNotificationType.BankNotificationPayNoc ||
    this.type === CustomerNotificationType.BankNotificationPayUndoNoc;
  }

  get isPrenote(): boolean {
    const meta = this.typedMetadata<BankNotificationPayMetadata>();
    return meta.prenoteSource !== undefined && meta.prenoteSource !== PrenoteSource.None;
  }

  get isTypeWithReturnedFunds(): boolean {
    return CustomerNotification.typesWithReturnedFunds.includes(this.type);
  }

  get formattedAcknowledgedBy(): string {
    return this.acknowledgedBy
      ? this.acknowledgedBy.split('(')[0].trim()
      : '';
  }

  typedMetadata<T>(): T {
    return Object.assign({} as T, this.metadata);
  }
}

export class BankNotificationPayMetadata {
    itemId: string;
    actionId: string;
    employeeName: string;
    employeeNumber: string;
    appliedUtcDateTime: Date;
    bankCode: string;
    amount: number;
    prenoteSource: PrenoteSource;
}

// TODO Remove this and use the one next time Smarthub Enums are generated
export enum PrenoteSource {
  None,
  Smarthub,
  UltiPro
}
